<div class="modal-backdrop show" (click)="onClose()"></div>

<div class="modal d-block pe-none" tabindex="-1">
<div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" (click)="$event.stopPropagation()">
  <div class="modal-content">
    <!-- Header -->
    <div class="modal-header">
      <h5 class="modal-title">{{ isEditMode ? 'Edit Certification' : 'Upload Certification' }}</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="onClose()" [disabled]="uploading"></button>
    </div>

    <!-- Body -->
    <div class="modal-body">
      <!-- Error Message -->
      <div *ngIf="errorMessage" class="alert alert-danger alert-dismissible fade show" role="alert">
        {{ errorMessage }}
        <button type="button" class="btn-close" aria-label="Close" (click)="errorMessage = ''"></button>
      </div>

      <form>
        <!-- Certification Type -->
        <div class="mb-3">
          <label for="certificationType" class="form-label">
            Certification Type <span class="text-danger">*</span>
          </label>
          <select
            id="certificationType"
            class="form-select"
            [(ngModel)]="certificationType"
            (ngModelChange)="onCertificationTypeChange()"
            name="certificationType"
            [disabled]="uploading || isEditMode"
            required>
            <option *ngFor="let type of certificationTypes" [value]="type.value">
              {{ type.label }}
            </option>
          </select>
        </div>

        <!-- Certificate Number -->
        <div class="mb-3">
          <label for="certificateNumber" class="form-label">
            Certificate Number <span class="text-danger">*</span>
          </label>
          <input
            type="text"
            id="certificateNumber"
            class="form-control"
            [(ngModel)]="certificateNumber"
            name="certificateNumber"
            placeholder="e.g., 44807-2024-12345"
            [disabled]="uploading"
            required>
        </div>

        <!-- Dates Row -->
        <div class="row">
          <div class="col-md-6">
            <div class="mb-3">
              <label for="issuedDate" class="form-label">
                Issued Date <span class="text-danger">*</span>
              </label>
              <input
                type="date"
                id="issuedDate"
                class="form-control"
                [(ngModel)]="issuedDate"
                name="issuedDate"
                [disabled]="uploading"
                required>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-3">
              <label for="expirationDate" class="form-label">
                Expiration Date
              </label>
              <input
                type="date"
                id="expirationDate"
                class="form-control"
                [(ngModel)]="expirationDate"
                name="expirationDate"
                [disabled]="uploading">
            </div>
          </div>
        </div>

        <!-- Issuing Authority -->
        <div class="mb-3">
          <label for="issuingAuthority" class="form-label">
            Issuing Authority <span class="text-danger">*</span>
          </label>
          <input
            type="text"
            id="issuingAuthority"
            class="form-control"
            [(ngModel)]="issuingAuthority"
            name="issuingAuthority"
            placeholder="e.g., FAA, State Department of Agriculture"
            [disabled]="uploading"
            required>
        </div>

        <!-- State (conditional) -->
        @if (certificationType === 'state-applicator') {
        <div class="mb-3">
          <label for="state" class="form-label">State</label>
          <app-us-state-select
            inputId="state"
            name="state"
            display="both"
            [(ngModel)]="state"
            [disabled]="uploading">
          </app-us-state-select>
        </div>
        }

        <!-- File Upload -->
        <div class="mb-3">
          <label for="fileUpload" class="form-label">
            Certificate File
          </label>
          <input
            type="file"
            id="fileUpload"
            class="form-control"
            (change)="onFileSelected($event)"
            accept=".pdf,.jpg,.jpeg,.png"
            [disabled]="uploading || uploadingFile">
          <small class="form-text text-muted">
            Accepted formats: PDF, JPG, PNG (Max 100MB)
          </small>
          <div *ngIf="uploadingFile" class="mt-2">
            <div class="spinner-border spinner-border-sm text-primary me-2" role="status">
              <span class="visually-hidden">Uploading...</span>
            </div>
            <span class="text-muted">Uploading file...</span>
          </div>
          <div *ngIf="uploadedFileUrl && !uploadingFile && !isEditMode" class="mt-2 text-success">
            <i class="bi bi-check-circle me-1"></i>
            File uploaded successfully
          </div>
          <div *ngIf="isEditMode && uploadedFileName && !selectedFile" class="mt-2 text-muted">
            <i class="bi bi-file-earmark me-1"></i>
            Current file: {{ uploadedFileName }}
          </div>
        </div>

        <!-- Notes -->
        <div class="mb-3">
          <label for="notes" class="form-label">
            Notes
          </label>
          <textarea
            id="notes"
            class="form-control"
            [(ngModel)]="notes"
            name="notes"
            rows="3"
            placeholder="Optional notes about this certification"
            [disabled]="uploading"></textarea>
        </div>
      </form>
    </div>

    <!-- Footer -->
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-secondary"
        (click)="onClose()"
        [disabled]="uploading">
        Cancel
      </button>
      <button
        type="button"
        class="btn btn-primary"
        (click)="onSubmit()"
        [disabled]="!isValid || uploading || uploadingFile">
        <span *ngIf="uploading" class="spinner-border spinner-border-sm me-2" role="status">
          <span class="visually-hidden">Uploading...</span>
        </span>
        {{ isEditMode ? 'Update Certification' : 'Upload Certification' }}
      </button>
    </div>
  </div>
</div>
</div>
